'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';

import { fetchDocumentsById } from '../../../../../utils/Content';

import ImgResized from '../../../../Widgets/ImgResized.react';
import Popup from '../../../../Widgets/Popup.react';

import './RecipeCard.scss';
import './CardAbstract.scss';

export default class RecipeCard extends Component {

    static contextTypes = {
        user: PropTypes.object,

        showRecipeDetails: PropTypes.func,
        onSelectRecipe: PropTypes.func,
        addSwapContext: PropTypes.object,
        showUpgradeForm: PropTypes.func,
    }

    onSelectRecipe = (ev) => {
        const { recipe } = this.props;
        const { onSelectRecipe, addSwapContext, user, showUpgradeForm } = this.context;
        const { params: { sort_by, sort_order }, searchRanking} = this.props;

        ev.stopPropagation();

        // Check if recipe is locked and user doesn't have meal_planner capability
        const { capabilities = {} } = user || {};
        const isTestMode = user?.email === 'vertaontest+0218@gmail.com';
        if ((recipe.protection !== 'public' && !capabilities.meal_planner) || isTestMode) {
            showUpgradeForm({ feature: 'meal_planner' });
            return;
        }

        onSelectRecipe(recipe, addSwapContext.participants, undefined, {searchRanking, sortBy: sort_by, sortOrder: sort_order, source: 'Smart Choices'});
    }

    render = () => {
        const { recipe, efficiencyDelta } = this.props;
        const { user, showRecipeDetails } = this.context;
        const { capabilities } = user || {};
        const isTestMode = user?.email === 'vertaontest+0218@gmail.com';

        return (
            <div className="card-abstract quick-recipe-card">
                {typeof efficiencyDelta === 'number' && efficiencyDelta >= 0 ? (
                    <div className="minimizes-waste-label">
                        MINIMIZES WASTE
                        <Popup className="el-popup-dark"
                            positionClassName="el-popup-right-bottom"
                            button={<i className="icon-info"/>}
                            buttonTitle="">
                            <p>This recipe uses ingredients that work well with your other planned meals, reducing your overall grocery costs and food waste.</p>
                        </Popup>
                    </div>
                ) : null}

                {/*typeof efficiencyDelta === 'number' && efficiencyDelta < 0 ? (
                    <div className="increases-waste-label">
                        INCREASES WASTE {(efficiencyDelta * -100).toFixed(2)}%
                    </div>
                ) : null*/}

                <ImgResized className="card-image" src={recipe.image} width={470} height={356} onClick={() => showRecipeDetails(recipe)} />

                {(recipe.tags || []).includes('Grab & Go') ?
                    <div className="card-overlay" onClick={() => showRecipeDetails(recipe)} >
                        Store Bought
                    </div>
                : null}

                <div className="card-info" onClick={() => showRecipeDetails(recipe)}>
                    <h3><em>{recipe.title}</em></h3>

                    <button onClick={this.onSelectRecipe}>
                        select meal
                        {((recipe.protection !== 'public' && !capabilities?.meal_planner) || isTestMode) ? <i className="icon-lock" /> : null}
                    </button>
                </div>
            </div>
        );
    }
}
